import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PieChart, Pie, Tooltip } from 'recharts';
import { DATA_COLORS } from '../../../constants/dataColors';
import { computeGroupSummary } from '../../../utils/groupingUtils';

function mapStateToProps(state) {
  return {
    assetSummary: state.assetInfo.assetSummary,
    assetGroup: state.assetInfo.assetGroup,
    currencyInfo: state.currencyInfo
  }
}

class AssetTypeSummaryPie extends Component {
  render() {
    const groupSummary = computeGroupSummary(this.props.assetSummary, this.props.assetGroup, this.props.currencyInfo);
    const totalValue = groupSummary.reduce((acc, r) => acc + parseFloat(r[1]), 0);
    const data = groupSummary.map((r, ridx) => ({
      name: r[0],
      value: parseFloat(r[1]),
      fill: DATA_COLORS[ridx],
    }));
    return (
      <PieChart width={600} height={400}>
        <Tooltip
          formatter={(value, name, { payload }) => {
            const percentage = (100 * payload.value / totalValue).toFixed(2);
            return [`${percentage} %`, `${payload.name}`];
          }}
        />
        <Pie data={data} cx="50%" cy="50%" labelLine={false} outerRadius={200} dataKey="value" />
      </PieChart>
    );
  }
}

export default connect(mapStateToProps)(AssetTypeSummaryPie);
